import { HiCalendarDays, HiChatBubbleLeftRight, HiHome } from 'react-icons/hi2';
import SectionHeading from '../components/SectionHeading';
import ScenarioCard from '../components/ScenarioCard';

/**
 * Illustrative situations, not testimonials. This section once quoted three
 * invented people (one with an invented therapist credential) as if they were
 * users. Keep it to situations and what the app actually offers for them.
 * `__tests__/no-invented-people.test.ts` fails if the old names come back.
 */
const scenarios = [
  {
    icon: HiChatBubbleLeftRight,
    title: 'Couples stuck in the same argument',
    description:
      'Learn to actually hear each other again. Short lessons teach you to name the feelings and needs under the fight, and the Giraffe Translator helps you turn blame into a clear request before you say it.',
  },
  {
    icon: HiHome,
    title: 'Parents of teens',
    description:
      'Tools to listen without losing your cool at the dinner table. Practice hearing the need behind the eye-roll with the lessons and Empy, the AI tutor. When you need to be heard yourself, join a live 1-on-1 empathy call or an empathy circle.',
  },
  {
    icon: HiCalendarDays,
    title: 'Alongside therapy',
    description:
      'A between-session practice tool therapists can recommend to clients: bite-sized NVC lessons, an AI tutor for rehearsing hard conversations, and live empathy circles. It supports therapy; it does not replace it.',
  },
];

export default function WhereItHelpsSection() {
  return (
    <section id="where-it-helps" className="ee-landing-section ee-landing-section--warm">
      <div className="ee-landing-container ee-landing-container--mid">
        <SectionHeading
          title="Where EmpathEase Helps"
          subtitle="A few common situations, and what the app gives you to work with in each."
        />

        <div className="ee-landing-grid ee-landing-grid--3">
          {scenarios.map((scenario, index) => (
            <ScenarioCard
              key={scenario.title}
              icon={scenario.icon}
              title={scenario.title}
              description={scenario.description}
              index={index}
            />
          ))}
        </div>
        <p className="ee-landing-note">
          Examples illustrate common situations. They are not individual user testimonials.
        </p>
      </div>
    </section>
  );
}
